import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgLeaderboardEmptyStateSecond = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 89,
  height: 104,
  viewBox: "0 0 89 104",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: [/*#__PURE__*/_jsx("rect", {
    width: 87.407,
    height: 87.997,
    x: 0.927,
    y: 16.001,
    fill: "#A7E3E3",
    rx: 12.837
  }), /*#__PURE__*/_jsx("circle", {
    cx: 44.639,
    cy: 23.992,
    r: 18.66,
    fill: "#1C456B"
  }), /*#__PURE__*/_jsx("circle", {
    cx: 44.639,
    cy: 23.992,
    r: 18.66,
    fill: "#1C456B"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#1C456B",
    d: "M59.067 58.787c.484 2.422-1.912 4.415-4.205 3.497l-9.064-3.625a3.1 3.1 0 0 0-2.31 0l-9.065 3.626c-2.293.917-4.689-1.076-4.205-3.498l2.792-13.963c.211-1.055 1.407-1.584 2.38-1.126a21.7 21.7 0 0 0 9.253 2.058c3.308 0 6.443-.738 9.25-2.058.974-.458 2.17.071 2.38 1.126z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#A7E3E3",
    d: "M44.854 23.42q.422-.673.597-1.195.2-.547.199-1.02 0-.92-.622-1.418-.597-.523-1.717-.523-.795 0-1.742.299a6.9 6.9 0 0 0-1.741.796l-.92-3.16q.946-.771 2.338-1.17a9.5 9.5 0 0 1 2.762-.422q1.667 0 2.96.622 1.32.597 2.066 1.791.746 1.17.746 2.837 0 1.269-.498 2.488-.472 1.22-1.567 2.836l-3.135 4.653-.473-.846h6.196v3.558H38.534z"
  })]
});
export default SvgLeaderboardEmptyStateSecond;